// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#fff","subMenuBg":"#fff","menuHover":"#001528","menuTextColor":"#9eadc5","menuTextActive":"#1890ff"};